/* eslint-disable camelcase */
import { init, vueRouterInstrumentation, Replay, BrowserTracing } from '@sentry/vue';
import { Router } from 'vue-router';
// eslint-disable-next-line import/extensions, import/no-unresolved
import { Options, Vue } from '@sentry/vue/types/types';

class VueAppElement extends HTMLElement {
  __vue_app__ = {
    config: {
      globalProperties: {
        $pinia: {
          state: {
            value: {},
          },
        },
      },
    },
  };
}

export const sentry = (app: Vue, router: Router) => {
  const LOCAL_DOMAINS = ['localhost', '127.0.0.1'];

  const {
    NODE_ENV,
    VUE_APP_SENTRY_DSN,
    VUE_APP_SENTRY_RELEASE,
    VUE_APP_API_URI,
    VUE_APP_MOCK_API,
    VUE_APP_STAGE,
  } = process.env;

  // do not run sentry code when running e2e tests
  if (LOCAL_DOMAINS.includes(window.location.hostname) || !VUE_APP_SENTRY_DSN || JSON.parse(VUE_APP_MOCK_API)) return;

  const environment = VUE_APP_STAGE || NODE_ENV;

  const params = {
    app,
    environment,
    trackComponents: true,
    dsn: VUE_APP_SENTRY_DSN,
    logErrors: environment !== 'production',
    integrations: [
      new BrowserTracing({
        routingInstrumentation: vueRouterInstrumentation(router),
        tracingOrigins: [...VUE_APP_API_URI, /^\//, 'cloudfront'],
      }),
      new Replay(),
    ],
    dom: {
      serializeAttribute: ['data-test'],
    },
    beforeSend: (event, hint) => {
      const el = document.getElementById('app') as VueAppElement;
      // eslint-disable-next-line no-param-reassign
      hint.attachments = [{
        filename: 'state.json',
        contentType: 'application/json',
        // eslint-disable-next-line no-underscore-dangle
        data: JSON.stringify(el.__vue_app__.config.globalProperties.$pinia.state.value),
      }];

      return event;
    },
    ignoreErrors: ['ResizeObserver loop limit exceeded'],
    // This sets the sample rate to be 10%. You may want this to be 100% while
    // in development and sample at a lower rate in production
    replaysSessionSampleRate: 0.1,
    // If the entire session is not sampled, use the below sample rate to sample
    // sessions when an error occurs.
    replaysOnErrorSampleRate: 1.0,
  } as Partial<Omit<Options, 'tracingOptions'>>;

  if (VUE_APP_SENTRY_RELEASE) {
    params.release = VUE_APP_SENTRY_RELEASE;
  }

  init(params);
};

export default sentry;
